// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Fq5N","bigColWidth":"Table_bigColWidth__2rPXd","biggerColWidth":"Table_biggerColWidth__Nl72j","row":"Table_row__1Ne4N","col":"Table_col__3FBUU"};